import { IAccountShort } from 'common/models';
import { getIsSelfRegistered } from 'entities/Account/Account.helper';

export const getPriceToDisplay = (price: number, priceWithTaxes: number, account?: IAccountShort): number => {
  if (!account) {
    return 0;
  }

  const isSelfRegistered = getIsSelfRegistered(account);

  return isSelfRegistered ? priceWithTaxes : price;
};
